import React, { useMemo, useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import VinylCover from './VinylCover.js';
import { listingGalleryUrls } from '../utils/listingGalleryUrls.js';

/**
 * Portada + miniaturas del artículo del pedido (disco o conjunto con varias fotos).
 */
export default function OrderListingMedia({ listingRow, stub, size = 'detail' }) {
  const urls = useMemo(() => listingGalleryUrls(listingRow || stub), [listingRow, stub]);
  const [active, setActive] = useState(0);
  const mainSize = size === 'compact' ? 72 : size === 'hero' ? 120 : 96;

  if (!urls.length) {
    return (
      <div style={{ width: mainSize, height: mainSize, borderRadius: 12, overflow: 'hidden', flexShrink: 0 }}>
        <VinylCover item={stub} />
      </div>
    );
  }

  const safeIdx = Math.min(active, urls.length - 1);
  const mainUrl = urls[safeIdx];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flexShrink: 0 }}>
      <div
        style={{
          width: mainSize,
          height: mainSize,
          borderRadius: 12,
          overflow: 'hidden',
          border: '0.5px solid rgba(255,255,255,0.12)',
          background: 'rgba(0,0,0,0.35)',
        }}
      >
        <img
          src={mainUrl}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>
      {urls.length > 1 ? (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', maxWidth: mainSize + 40 }}>
          {urls.map((url, i) => (
            <button
              key={url}
              type="button"
              onClick={() => setActive(i)}
              style={{
                width: 40,
                height: 40,
                padding: 0,
                borderRadius: 8,
                overflow: 'hidden',
                border: i === safeIdx ? `1.5px solid ${C.gold}` : '0.5px solid rgba(255,255,255,0.15)',
                background: 'rgba(0,0,0,0.4)',
                cursor: 'pointer',
                opacity: i === safeIdx ? 1 : 0.75,
              }}
              aria-label={`Foto ${i + 1}`}
            >
              <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

/** Miniaturas del artículo dentro de un paso del timeline. */
export function OrderStepProductThumbs({ urls, max = 4 }) {
  if (!urls?.length) return null;
  const shown = urls.slice(0, max);
  return (
    <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      {shown.map(url => (
        <img
          key={url}
          src={url}
          alt=""
          style={{
            width: 44,
            height: 44,
            borderRadius: 8,
            objectFit: 'cover',
            border: '0.5px solid rgba(255,255,255,0.15)',
          }}
        />
      ))}
      {urls.length > max ? (
        <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>+{urls.length - max} fotos</span>
      ) : null}
    </div>
  );
}
